import { get } from 'lodash';
import { useEffect, useState } from 'react';
import DocumentTitle from 'react-document-title';
import { useParams, useSearchParams } from 'react-router-dom';

import { Card } from '@hivebrite/design-system/Card';

import UpdateUserData from 'hb-react/frontoffice/apps/UpdateUserData';
import { useDonationContext } from 'hb-react/frontoffice/contexts/DonationContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import Cover from 'hb-react/shared/apps/Donations/components/Cover';
import Success from 'hb-react/shared/apps/Donations/components/Success';
import fetchOrder from 'hb-react/shared/apps/Donations/requests/fetchOrder';
import Loader from 'hb-react/shared/components/Loader';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import { getPageTitleFromNetwork } from 'hb-react/shared/utils/getPageTitleFromNetwork';

const DonationsSuccessContainer = () => {
  const [order, setOrder] = useState(null);
  const params = useParams();

  const { currentUser, currentNetwork } = useDefaultAppContexts();
  const { whitelabelURL } = useDonationContext();
  const whitelabelURLEnabled = currentUser ? false : whitelabelURL;

  useEffect(() => {
    const campaignId = params?.campaignId;

    fetchOrder(campaignId, whitelabelURLEnabled, {}, ({ order }) => {
      setOrder(order);
    });
  }, [params, whitelabelURLEnabled]);

  const [search] = useSearchParams();
  const { order_id: orderId } = Object.fromEntries(search);

  const campaign = get(order, 'campaign');
  const networkTitle = get(order, ['meta', 'network_title']);
  const sharingParameters = {};

  if (campaign) {
    sharingParameters.title = s__(
      'donation|I just made a gift to "%{networkTitle}". Join me in being a force for good at ',
    ).i__({ networkTitle });
    sharingParameters.url = campaign.sharing_url;
  }

  if (!campaign) {
    return <Loader fillParent />;
  }

  const documentTitle = `${s__(
    'PageTitle|Successful donation to %{campaignTitle}',
  ).i__({ campaignTitle: campaign.title })}`;

  return (
    <>
      <DocumentTitle
        title={generatePageTitle({
          title: documentTitle,
          networkName: getPageTitleFromNetwork(currentNetwork),
        })}
      />
      <Cover imageUrl={order.campaign.cover_image_url}>
        <div className="container--centered container--small portable--soft-half--sides">
          <div className="push--bottom">
            <Card>
              <Success
                successPageContent={get(campaign, 'success_page')}
                headline={get(order, ['meta', 'success_headline'])}
                tagline={get(order, ['meta', 'success_tagline'])}
                sharingParameters={sharingParameters}
              />
            </Card>
          </div>
          {currentUser && orderId && (
            <UpdateUserData
              config={{
                getDataUrl: Routes.users_updated_data_path({
                  entity_id: orderId,
                  entity_type: 'donation',
                }),
              }}
            />
          )}
        </div>
      </Cover>
    </>
  );
};

export default DonationsSuccessContainer;
